<template>
  <div>
    <!-- Message d'erreur -->
    <ul
      v-if="serverErrorMsg"
      class="a-input-message a-input-message--error js-a-input-message--error filled"
    >
      <li
        class="a-input-message__error-item js-a-input-message__error-item"
      >
        {{ serverErrorMsg }}
      </li>
    </ul>
  </div>
</template>

<script>
import { useReCaptcha } from 'vue-recaptcha-v3'
import {computed} from "vue";

export default {
  name: 'RecaptchaV3Form',
  props: {
    action: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    serverErrors: {
      type: Array,
      required: true
    },
  },
  setup(props) {
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()

    const submit = async () => {
      // (optional) Wait until recaptcha has been loaded.
      await recaptchaLoaded()

      // Execute reCAPTCHA
      return await executeRecaptcha(props.action)
    }

    const serverErrorMsg = computed(() => {
      for(const error of props.serverErrors) {
        if (error.propertyPath === props.slug) {
          return error.message
        }
      }
      return ''
    })

    return {
      submit,
      serverErrorMsg
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
